import React from "react";
import { Box } from "@mui/material";
import { styled } from "@mui/material/styles";
import { useLayoutConstants } from "@BehpardazBarin/frontend_components";
import { useLocation, Outlet } from "react-router-dom";
import Footer from "../components/Layout/Footer/Footer";
import Header from "../components/Layout/header/Header";
import { useMobileWithLogo } from "../hooks/use-mobileWithLogo";

const LeftPane = styled(Box)(({ theme }) => ({
  flex: 1,
  backgroundImage: `
    radial-gradient(70% 100%  at bottom, #FAF7F2 0%, #C49A5A 50%),
    url("/icons/bgPattern.svg")
  `,
  backgroundRepeat: "repeat",
  backgroundSize: "auto",
  backgroundBlendMode: "overlay",
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  flexDirection: "column",
  padding: theme.spacing(4),
  color: theme.customColors.neutral[10],
}));

const RightPane = styled(Box)(({ theme }) => ({
  flex: 1,
  backgroundColor: theme.customColors.neutral.surfaceContainerLowest,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  padding: theme.spacing(4),
}));

const Layout: React.FC = () => {
  const { pathname } = useLocation();
  const { isMobile } = useLayoutConstants(pathname);
  const mobileWithLogo = useMobileWithLogo();

  //Mobile
  if (isMobile) {
    return (
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="space-between"
        minHeight="100vh"
        px={2}
        sx={{
          backgroundImage: `
  radial-gradient(70% 100%  at bottom, #FAF7F2 0%, #e0c6a4 50%),
  url("/icons/bgPattern.svg")
`,
          backgroundRepeat: "repeat",
          backgroundSize: "auto",
          backgroundBlendMode: "overlay",
        }}
      >
        <Box mt={2}>
          {mobileWithLogo && <Header width={110} height={130} />}
        </Box>
        <Box width="100%" maxWidth={400}>
          <Outlet />
        </Box>
        <Footer />
      </Box>
    );
  }
  //Descktop
  return (
    <Box display="flex" minHeight="100vh">
      <RightPane>
        <Box width="100%" maxWidth={480}>
          <Outlet />
        </Box>
      </RightPane>
      <LeftPane>
        <Box
          sx={{
            flex: 1,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            mt: 10,
          }}
        >
          <Header width={180} height={200} />
        </Box>
        <Footer />
      </LeftPane>
    </Box>
  );
};

export default Layout;
